module.exports = __webpack_public_path__ + "img/CIMG1149.15b87d1a.jpg";